<div class="row">
  <div class="col-xs-12 col-12">
    <pagination
      [directionLinks]="false"
      [totalItems]="totalItems"
      [(ngModel)]="currentPage"
      (numPages)="smallnumPages = $event">
    </pagination>
  </div>
</div>

<div class="row">
  <div class="col-xs-12 col-12">
    <pager
      [totalItems]="totalItems"
      [(ngModel)]="currentPage"
      (pageChanged)="pageChanged($event)"
      pageBtnClass="btn"
      [itemsPerPage]="10"
      class="pull-left">
    </pager>
  </div>
</div>
